// @flow
import * as Immutable from 'immutable';
import ImmutableModel from './ImmutableModel';
import { TeamId } from './TeamId';
import type { TeamIdModelType } from './TeamId';

export type EventStatusEnum = 'OK' | 'BREACHED' | 'RESOLVED' | 'ERROR';
export type EventTypeEnum =
    | 'USER_BATTERY_LEVEL'
    | 'USER_LOC_GAP'
    | 'VEHICLE_FREEZER_TEMPERATURE'
    | 'TASK_ACCEPT_DELAY'
    | 'TASK_ETA_DELAY_COMPLETED'
    | 'TASK_SLA_DELAY_COMPLETED'
    | 'TASK_LOC_FAR_ARRIVED'
    | 'TASK_TEMPERATURE_BREACH'
    | 'USER_HALT';

export type MetricEventModelType = {
    clientId: string,
    eventName: string,
    eventId: string,
    status: EventStatusEnum,
    teamId: TeamIdModelType,
    resolvedAt: string,
    breachedAt: string,
    breachedSince: string,
    eventType: EventTypeEnum
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class MetricEvent extends ImmutableModel {
    static fromJS(json: MetricEventModelType): MetricEvent {
        const state: Object = Object.assign({}, json);
        state.teamId = TeamId.fromJS(state.teamId);
        return new this(Immutable.Map(state));
    }

    toJS(): MetricEventModelType {
        return {
            clientId: this.clientId,
            eventName: this.eventName,
            eventId: this.eventId,
            status: this.status,
            teamId: this.teamId.toJS(),
            resolvedAt: this.resolvedAt,
            breachedAt: this.breachedAt,
            breachedSince: this.breachedSince,
            eventType: this.eventType
        };
    }

    get clientId(): string {
        return this._state.get('clientId');
    }

    setClientId(clientId: string): this {
        return this.clone(this._state.set('clientId', clientId));
    }

    get eventName(): string {
        return this._state.get('eventName');
    }

    setEventName(eventName: string): this {
        return this.clone(this._state.set('eventName', eventName));
    }

    get eventId(): string {
        return this._state.get('eventId');
    }

    setEventId(eventId: string): this {
        return this.clone(this._state.set('eventId', eventId));
    }

    get status(): EventStatusEnum {
        return this._state.get('status');
    }

    setStatus(status: EventStatusEnum): this {
        return this.clone(this._state.set('status', status));
    }

    get teamId(): TeamId {
        return this._state.get('teamId');
    }

    setTeamId(teamId: TeamId): this {
        return this.clone(this._state.set('teamId', teamId));
    }

    get resolvedAt(): string {
        return this._state.get('resolvedAt');
    }

    setResolvedAt(resolvedAt: string): this {
        return this.clone(this._state.set('resolvedAt', resolvedAt));
    }

    get breachedAt(): string {
        return this._state.get('breachedAt');
    }

    setBreachedAt(breachedAt: string): this {
        return this.clone(this._state.set('breachedAt', breachedAt));
    }

    get breachedSince(): string {
        return this._state.get('breachedSince');
    }

    setBreachedSince(breachedSince: string): this {
        return this.clone(this._state.set('breachedSince', breachedSince));
    }

    get eventType(): EventTypeEnum {
        return this._state.get('eventType');
    }

    setEventType(eventType: EventTypeEnum): this {
        return this.clone(this._state.set('eventType', eventType));
    }
}
